var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "__pop-nutritional",
          attrs: {
            title: "权益描述",
            top: "10vh",
            center: true,
            visible: _vm.isShow,
            "append-to-body": true,
          },
          on: {
            close: _vm.closePop,
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content-box" },
            [
              _c("Tinymce", {
                model: {
                  value: _vm.description,
                  callback: function ($$v) {
                    _vm.description = $$v
                  },
                  expression: "description",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-item cancel-btn",
                  on: { click: _vm.closePop },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }